document.documentElement.classList.add('sp-motion-ready');

(function(){
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  ready(function(){
    if(!document.documentElement.classList.contains('template-index')) return;
    var reveal=document.querySelectorAll('[data-sp26-reveal]');
    if('IntersectionObserver' in window){
      var revealObs=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObs.unobserve(entry.target);}});},{threshold:.10,rootMargin:'0px 0px -4% 0px'});
      reveal.forEach(function(el){revealObs.observe(el);});
    }else{reveal.forEach(function(el){el.classList.add('is-visible');});}

    var desktop=window.matchMedia('(min-width: 990px)');
    var depthEls=document.querySelectorAll('[data-sp26-depth]');
    function clamp(v,min,max){return Math.max(min,Math.min(max,v));}
    function clearDepth(){depthEls.forEach(function(el){el.style.transform='';});}
    function parallax(){
      if(!desktop.matches){clearDepth();return;}
      var h=window.innerHeight||1;
      depthEls.forEach(function(el){
        var speed=parseFloat(el.getAttribute('data-sp26-depth')||'0');
        var r=el.getBoundingClientRect();
        var center=r.top+r.height/2;
        var d=(center-h/2)/h;
        var y=clamp(d*speed*-210,-150,150);
        var base=0;
        if(el.classList.contains('sp26-float-card--1'))base=-8;
        if(el.classList.contains('sp26-float-card--2'))base=8;
        if(el.classList.contains('sp26-float-card--3'))base=-5;
        if(el.classList.contains('sp26-float-card--4'))base=6;
        var rotate=clamp(d*speed*10,-9,9);
        if(el.classList.contains('sp26-float-card')) el.style.transform='translate3d(0,'+y+'px,0) rotate('+(base+rotate)+'deg)';
        else el.style.transform='translate3d(0,'+y+'px,0)';
      });
    }
    var scheduled=false;
    function onScroll(){if(!scheduled){scheduled=true;requestAnimationFrame(function(){parallax();scheduled=false;});}}
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll);
    if(desktop.addEventListener)desktop.addEventListener('change',function(){clearDepth();parallax();});
    parallax();

    var story=document.querySelector('[data-sp26-story]');
    if(story && 'IntersectionObserver' in window && desktop.matches){
      var steps=story.querySelectorAll('[data-sp26-story-step]');
      var visuals=story.querySelectorAll('[data-sp26-story-visual]');
      var number=story.querySelector('[data-sp26-story-number]');
      var progress=story.querySelector('[data-sp26-story-progress]');
      function activate(n){
        steps.forEach(function(el){el.classList.toggle('is-active',el.getAttribute('data-sp26-story-step')===String(n));});
        visuals.forEach(function(el){el.classList.toggle('is-active',el.getAttribute('data-sp26-story-visual')===String(n));});
        if(number)number.textContent='0'+n;
        if(progress)progress.style.width=(n*25)+'%';
      }
      var storyObs=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){activate(parseInt(entry.target.getAttribute('data-sp26-story-step'),10));}});},{threshold:.58,rootMargin:'-12% 0px -12% 0px'});
      steps.forEach(function(el){storyObs.observe(el);});
    }
  });
})();

;(function(){
  var root=document.querySelector('[data-sp58-parallax-root]');
  if(!root || window.matchMedia('(max-width: 989px)').matches) return;
  var items=root.querySelectorAll('[data-sp58-depth]');
  var ticking=false;
  function update(){
    var r=root.getBoundingClientRect(), vh=window.innerHeight||800;
    var progress=(r.top+r.height/2-vh/2)/vh;
    items.forEach(function(el){var d=parseFloat(el.getAttribute('data-sp58-depth')||0);var y=Math.max(-28,Math.min(28,progress*d*-80));el.style.transform='translate3d(0,'+y+'px,0)';});
    ticking=false;
  }
  window.addEventListener('scroll',function(){if(!ticking){requestAnimationFrame(update);ticking=true;}},{passive:true});
  update();
})();


// V5.9 truthful countdown: renders only when a real offer-end metafield is supplied.
(function(){
  function initSp59Countdown(){
    document.querySelectorAll('[data-sp59-countdown]').forEach(function(el){
      var raw = el.getAttribute('data-end');
      var clock = el.querySelector('[data-sp59-clock]');
      if(!raw || !clock) return;
      var end = new Date(raw).getTime();
      if(!isFinite(end)){ el.style.display='none'; return; }
      function tick(){
        var diff = end - Date.now();
        if(diff <= 0){ el.style.display='none'; return; }
        var h = Math.floor(diff/3600000);
        var m = Math.floor((diff%3600000)/60000);
        var s = Math.floor((diff%60000)/1000);
        clock.textContent = String(h).padStart(2,'0')+':'+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0');
      }
      tick(); setInterval(tick,1000);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initSp59Countdown); else initSp59Countdown();
})();
